import { render, staticRenderFns } from "./contract_draft_work_construction.vue?vue&type=template&id=18bbe5ea&scoped=true"
import script from "./contract_draft_work_construction.vue?vue&type=script&lang=js"
export * from "./contract_draft_work_construction.vue?vue&type=script&lang=js"
import style0 from "./contract_draft_work_construction.vue?vue&type=style&index=0&id=18bbe5ea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18bbe5ea",
  null
  
)

export default component.exports